export default __webpack_public_path__ + "static/image/slider3_1.f3c10791.jpg";